<script>
  export default {
    mounted() {
      this.$root.botaoAcaoMostrar = false;

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';
    }
  }
</script>

<template>
  <router-view :key="$route.path"></router-view>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio-tecnico-projeto/componentes/RelatorioTecnicoProjeto.vue